import React from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountdown from '../useCountdown';
import {
  Container,
  Frame,
  FrameContainer,
  Logo,
  Time,
  Title,
  Video,
} from './styles';

function CountdownSquidCraft({ data, styles }) {
  const haveTitle = !!data.title;

  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'notoSans'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'notoSans'];

  const [hours, minutes, seconds] = useCountdown({
    audioUrl: data.audioUrl,
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container>
        {data?.logo && <Logo src={data.logo} alt="Logo" />}
        <FrameContainer>
          <Frame>
            <Video autoPlay loop muted>
              <source
                src="https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-background.webm"
                type="video/webm"
              />
              Your browser does not support the video tag.
            </Video>
          </Frame>
          <Time
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
              lineHeight: styles?.timer?.size
                ? `${styles?.timer?.size}px`
                : undefined,
            }}
          >
            {`${hours}:${minutes}:${seconds}`}
          </Time>
        </FrameContainer>
        {haveTitle && (
          <Title
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {data.title}
          </Title>
        )}
      </Container>
    </>
  );
}

CountdownSquidCraft.propTypes = {
  data: PropTypes.shape({
    audioUrl: PropTypes.string,
    logo: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountdownSquidCraft.defaultProps = {
  data: {
    audioUrl: null,
    logo: 'https://overlayon.s3.eu-west-3.amazonaws.com/logo-squid-craft-2.png',
    status: 'paused',
    time: [],
    title: 'Time Remaining',
  },
  styles: {
    timer: {
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 1,
      size: 50,
    },
    title: {
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 1,
      size: 36,
    },
  },
};

export default CountdownSquidCraft;
